import * as _ from 'lodash';
import createSelector from 'selectorator';

import type { ReduxStore } from '../store';

import type { PolicyStore } from './store';

const getPolicies = createSelector<ReduxStore, PolicyStore['policies']>(['policies.policies'], policies => policies);

const policySelectors = {
  getPolicies,
  getPolicyList: createSelector([getPolicies], _.values),
  getStatus: createSelector([`policies.status`], (status) => status),
  getCurrentPolicy: (state: ReduxStore, props: { params: { policyId: number } }) =>
    state.policies.policies[props.params.policyId],
  getExceptions: createSelector(['policies.exceptions'], (exceptions) => exceptions),
};

export default policySelectors;
